import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { PlatformType } from '@root/config';
import { CtripPriceFormService } from '../../ctrip-price-form/ctrip-price-form.service';
import _, { add } from 'lodash';
import { addThousandsSeparator, removeThousandsSeparator } from '@root/util/number';
import { PriceChild } from '@root/router/component/calendar/multi-house-calendar/multi-house-calendar.service';

@Component({
  selector: 'host-edit-price-form-item',
  templateUrl: './edit-price-form-item.component.html',
  styleUrls: ['./edit-price-form-item.component.scss'],
})
export class EditPriceFormItemComponent implements OnInit, AfterViewInit {
  readonly Platform: typeof PlatformType = PlatformType;
  @Input() data;
  @Input() disabled = false;
  @Input() active: boolean = false;
  @Input() displayThousandsSep = false;

  get entity(): PriceChild {
    return this.data?.house_info;
  }
  /**
   * 4.3.0新加
   * 产品要求输入框 blur 时展示千分符，focus 时不展示千分符，所以这里将其单独拆分出来
   */
  get formattedPrice(): string {
    if (this.displayThousandsSep) {
      return this.addThousandsSeparator(this.data?.price);
    }
    return this.data?.price;
  }
  get formattedPlaceholder(): string {
    if (this.displayThousandsSep) {
      return this.addThousandsSeparator(this.data?.placeholder);
    }
    return this.data?.placeholder;
  }

  constructor(private ctripPriceFormService: CtripPriceFormService) {}

  ngOnInit() {}

  ngAfterViewInit(): void {}

  addThousandsSeparator(value) {
    return addThousandsSeparator(value);
  }
  recalculateCtripPrice(data) {
    if (!_.isNil(data.price)) {
      data.reserve_price = this.calculateReservePrice(data.commission_rate * 100, data.price);
      data.sale_price = data.price;
    }
  }

  private calculateReservePrice(commission, salePrice) {
    return this.ctripPriceFormService.calculateReservePrice(commission, salePrice);
  }

  ctripReservePriceText(data) {
    if (_.isNil(data.price)) {
      return data.max_reserve_price === data.min_reserve_price
        ? data.min_reserve_price
        : `${data.min_reserve_price}~${data.max_reserve_price}`;
    }

    return data.reserve_price;
    // return this.calculateReservePrice(data.commission_rate * 100, data.price);
  }

  onClearCtripPriceForm(form) {
    form.price = null;
    form.placeholder = '';

    form.reserve_price = form.init_reserve_price;
    form.sale_price = null;

    form.displayCtripPriceForm = false;
  }

  onConfirmCtripPriceForm(form, data) {
    form.commission_rate = data.commission / 100;
    form.sale_price = data.salePrice;
    form.reserve_price = data.reservePrice;
    form.price = data.salePrice;

    form.displayCtripPriceForm = false;
  }
}
